var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 7.99992C13.3332 10.9399 10.9398 13.3333 7.99984 13.3333C5.05984 13.3333 2.6665 10.9399 2.6665 7.99992C2.6665 5.05992 5.05984 2.66658 7.99984 2.66658C10.9398 2.66659 13.3332 5.05992 13.3332 7.99992ZM14.6665 7.99992C14.6665 4.31992 11.6798 1.33325 7.99984 1.33325C4.31984 1.33325 1.33317 4.31992 1.33317 7.99992C1.33317 11.6799 4.31984 14.6666 7.99984 14.6666C11.6798 14.6666 14.6665 11.6799 14.6665 7.99992ZM5.99984 7.99992L8.6665 5.33325L8.6665 10.6666L5.99984 7.99992Z",
    fill: "#1A4C8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackColor);
export default __webpack_public_path__ + "static/media/back_Color.8a6bd9f54b1639c98c6df0bd6bb69675.svg";
export { ForwardRef as ReactComponent };